import  {combineReducers } from "redux"; 
import caseDetailsReducer from "../reducers/CaseDetailsReducer";
import loginReducer from "../reducers/LoginReducer";
import userDetailsReducer from "../reducers/UserDetailsReducer"

const rootReducer = combineReducers({
    lognReducer: loginReducer,
    usersReducer : userDetailsReducer,
    caseReducer : caseDetailsReducer

})

export default rootReducer;